import StantMultiselect from"../../../utils/stant_multiselect.coffee"

$(document).on 'turbolinks:load', ->
  new StantMultiselect('traceabilities-trucks-multiselect').add_listener()